/** @format */

import React from 'react';
import {Box, Container} from '@chakra-ui/layout';
import Patterns from '../../patterns';
import Layout from '../../components/layout';
import {getNewsItemContentNode} from '../../lib/api/contentNodes';
import {getSeoFields} from '../../lib/getSeoFields';
import {getContentTypes} from '../../lib/api/contentTypes';
import {NextSeo} from 'next-seo';
import getFooter from '../../lib/api/acf/footer';
import mappingFooter from '../../patterns/Footer/mappingFooter';

import mappingMainMenu from '../../patterns/MainMenu/mappingMainMenu';
import {GetStaticPaths, GetStaticProps} from 'next';
import mappingNavBar from '../../patterns/NavBar/mappingNavBar';
import NewsPostHeader from '../../components/news-post-header';
import ErrorPage from 'next/error';

import {
	getMainMenu,
	getGlobalMainMenu,
	getParentSiteMainMenu,
	getEventsMenu,
} from '../../lib/api/acf/navBarMenu';
import {identifySubdomain} from '../../utils';
import {getAllNewsItems} from '../../lib/api';

function NewsItem({post, seo, navBar, footer, subdomain}) {
	// console.log('-- NewsItem --');

	if (!post) return <ErrorPage statusCode={404} />;

	const {title, categories, author, modifiedGmt} = post;
	const {firstName, lastName, name} = author.node;

	return (
		<Layout
			seo={post.seo}
			navBar={navBar}
			footer={footer}
			subdomain={subdomain}>
			<NextSeo {...seo} />

			<Box>
				<Box bg='white' as='section' overflow='hidden' position='relative'>
					<Container
						position='relative'
						maxW={{base: 'container.xl', lg: '1440px'}}
						mx='auto'></Container>
					<NewsPostHeader
						title={post.title}
						coverImage={post.featuredImage}
						date={post.date}
						author={author}
						categories={post.categories}
						subdomain={subdomain}
					/>
				</Box>
				<>
					{post.pageLayout.flexibleContent.map((post: any, index: number) => {
						return (
							<Patterns
								fieldGroupName={post.__typename}
								post={post}
								subdomain={subdomain}
								key={`${post.fieldGroupName}_${index}`}
							/>
						);
					})}
				</>
			</Box>
		</Layout>
	);
}

export const getStaticPaths: GetStaticPaths = async () => {
	const allPages = await getAllNewsItems();
	// let contentTypes = await getContentTypes();

	// contentTypes = contentTypes?.filter(
	// 	contentType => contentType.name !== 'newsItem',
	// );
	// console.log('news-item slug template');
	console.log(allPages);

	// const uris = contentTypes

	// 	.map(contentType => contentType.contentNodes.nodes)
	// 	.flat()

	// 	.map(({uri}) => uri);
	// return {
	// 	paths: uris,
	// 	fallback: 'blocking',
	// };

	return {
		paths: allPages,
		fallback: true,
	};
};

export async function getStaticProps({params, preview, previewData}) {
	const subdomain = params?.site || '';
	const id = `/news-item/${params.slug}`;

	const idType = preview ? 'DATABASE_ID' : 'URI';

	const post = await getNewsItemContentNode(id, idType, preview, subdomain);
	const seo = !preview ? getSeoFields(post) : null;
	// console.log('============ Returned Postdata: ', post);

	let footer = await getFooter(subdomain);
	footer = mappingFooter(footer);

	// Menus
	const globalMainMenu = await getGlobalMainMenu('');
	// const mainMenu = await getMainMenu('');
	const parentSiteMenu = await getParentSiteMainMenu('');
	const mainMenu = await getMainMenu('');

	let navBar: any = [];

	if (mainMenu && globalMainMenu && parentSiteMenu) {
		navBar = mappingNavBar({globalMainMenu, parentSiteMenu, mainMenu});
	}

	const subdomainStr = identifySubdomain(post?.link);
	preview = false;

	return {
		props: {post, seo, navBar, footer, subdomain: subdomainStr},
		revalidate: 150,
	};
}

export default NewsItem;
